export const environment = {
  production: true,
  name: 'production',

  backend: {
    url: 'https://api.worldconquer.online',
  },
  recaptcha: {
    siteKey: '6LdDDzMqAAAAAG0FK_Y1APlyFLGmUr6HISy8SMvV',
  },
  ckeditor: {
    licenseKey: 'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3ODUyODMxOTksImp0aSI6ImRiZGRkNDU1LWExMGMtNGFiYS05MmE4LTJmMWM3N2QwMzczOCIsImxpY2Vuc2VkSG9zdHMiOlsid29ybGRjb25xdWVyLm9ubGluZSJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sImZlYXR1cmVzIjpbIkRSVVAiLCJFMlAiLCJFMlciXSwidmMiOiJkOGQzM2I2ZSJ9.TuhdknbYR42fnEB-Q-GXnO6FJbeEtQKkLYoQNCkd-0lo_MB4YzCnIGXpDFR2aGuecPCVbAFsOlodkqsc-NTqBw',
    cloudConfig: {
      version: '46.0.0'
    }
  }
};
